module.exports = __webpack_public_path__ + "static/img/img_cesium.72a1c3f0.png";